import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { ReportProvider } from 'src/app/providers';
import { ReportService, ToasterService } from 'src/app/services';

@Component({
  selector: 'ist-action-context-menu',
  templateUrl: './ist-action-context-menu.component.html',
  styleUrls: ['./ist-action-context-menu.component.scss']
})
export class IstActionContextMenuComponent{

  @Input() columnName: string;
  @Input() versionId: string;
  @Input() activeAction: string = '';
  @Input() revenuePercentage: number = 0;
  @Input() historicalVisible: boolean = true;
  @Input() isClickable: boolean = false;

  @Output() percentDialogOpen = new EventEmitter();

  @ViewChild('contextMenu') contextMenu;
  contextMenuVisible: boolean = false;

  percentDialogVisible: boolean = false;
  selectedOption: string = '';
  maxLengthForPercentage: number = 3;

  constructor(private reportProvider: ReportProvider,
    private toastr: ToasterService,
    public reportService: ReportService) { }

  toggleContextMenu(event: any) {
    event.preventDefault();
    setTimeout(() => {
      this.contextMenuVisible = true;
    }, 10);
  }

  @HostListener('document:click', ['$event.target'])
  clickedOutside(targetElement){
    if (this.contextMenu) {
      const clickedInside = this.contextMenu.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.contextMenuVisible = false;
      }
    }
  }

  @HostListener('document:contextmenu', ['$event.target'])
  rightClickedOutside(targetElement){
    if (this.contextMenu && this.contextMenuVisible) {
      const clickedInside = this.contextMenu.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.contextMenuVisible = false;
      }
    }
  }

  actionClick(actionName: string, value: number = 0) {
    this.contextMenuVisible = false;
    this.reportProvider.actionApply(this.versionId, this.columnName, actionName, value).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  togglePercentDialog() {
    this.contextMenuVisible = false;
    this.revenuePercentage = this.reportService.report.getValue().LATEST.IS_INCREASE_PERCENTAGE;
    this.percentDialogVisible = !this.percentDialogVisible;
    this.percentDialogOpen.emit(this.percentDialogVisible);
  }

  decreasePercent(): void {
    this.revenuePercentage = this.revenuePercentage ? Number(this.revenuePercentage.toString()) : 0;
    if (this.revenuePercentage > -999)
      this.revenuePercentage--;
  }

  increasePercent(): void {
    this.revenuePercentage = this.revenuePercentage ? Number(this.revenuePercentage.toString()) : 0;
    if (this.revenuePercentage < 999)
      this.revenuePercentage++;
  }

  acceptPercentDialog() {
    this.revenuePercentage = this.revenuePercentage ? this.revenuePercentage : 0;
    this.reportService.report.getValue().LATEST.IS_INCREASE_PERCENTAGE = this.revenuePercentage;
    this.actionClick('INCREASE_PERCENT', this.revenuePercentage);
    this.togglePercentDialog();
  }

  @HostListener('window:keyup.enter', ['$event'])
  onKeyUp($event: KeyboardEvent) {
    if (this.percentDialogVisible)
      this.acceptPercentDialog();
  }

  keyupForPercentage(event: any) {
    const value = event.target.value;
    if(Number(value) < 0) {
      this.maxLengthForPercentage = 4;
    } else {
      this.maxLengthForPercentage = 3;
    }
  }

}
